import React from 'react';
import { styled } from '@mui/system';
const StyledContent = styled('div')(({
  theme,
  customStyle
}) => ({
  [theme.breakpoints.down(2300)]: {
    width: '75%'
  },
  [theme.breakpoints.down(2000)]: {
    width: '90%'
  },
  [theme.breakpoints.down(600)]: {
    width: '95%'
  },
  [theme.breakpoints.down(400)]: {
    width: '98%'
  },
  margin: '0 auto 100px auto',
  width: '65%',
  maxWidth: 1350,
  ...customStyle
}));
const Content = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(StyledContent, props, props.children));
export default Content;